import { type Client, graphql, prefetch } from "@opensea/graphql"
import { ActivityItemCardFragment } from "@/components/collection/explore/components/ActivityItemCard/ActivityItemCard.fragment"

export const CollectionTopSalesQuery = graphql(
  `
    query CollectionTopSalesQuery($collectionSlug: String!) {
      topCollectionSales(collectionSlug: $collectionSlug) {
        id
        ...ActivityItemCard
      }
    }
  `,
  [ActivityItemCardFragment],
)

export const prefetchCollectionTopSalesQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionTopSalesQuery, { collectionSlug })
}
